"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Shimmer/index"), exports);
//# sourceMappingURL=Shimmer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/Shimmer.js
// module id = 1161
// module chunks = 0